import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OverlayDirective } from '@directives/overlay.directive';
import { SvgIconComponent } from 'angular-svg-icon';
import { SidebarComponent } from './sidebar.component';
import { MenuComponent } from './menu/menu.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [MenuComponent, SidebarComponent],
    imports: [
        CommonModule,
        RouterModule,
        SvgIconComponent,
        LayoutModule,
        OverlayModule,
        OverlayDirective,
        TranslateModule,
    ],
    exports: [SidebarComponent],
})
export class SidebarModule {}
